/* Automatic service notice. Manual maintenance remains controlled by Liquid. */
(() => {
 'use strict';
 const notice=document.querySelector('[data-sutton-service-notice]');
 if(!notice)return;
 const endpoint=notice.dataset.statusEndpoint;
 if(!endpoint)return;
 let active=false,failures=0,successes=0,busy=false;
 const render=visible=>{if(active===visible)return;active=visible;notice.hidden=!visible;notice.setAttribute('aria-hidden',String(!visible));};
 async function check(){
  if(busy||document.visibilityState==='hidden')return;
  busy=true;
  const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),8000);
  try{
   const response=await fetch(endpoint,{mode:'cors',credentials:'omit',headers:{Accept:'application/json'},signal:controller.signal});
   if(!response.ok)throw new Error('Status unavailable');
   const status=await response.json();
   if(status.v!==1||typeof status.incidentActive!=='boolean'||typeof status.enabled!=='boolean')throw new Error('Status unavailable');
   failures=0;successes++;
   if(!status.enabled){render(false);return;}
   if(status.incidentActive){successes=0;render(true);}
   else if(successes>=2||!active)render(false);
  }catch(_){successes=0;failures++;if(failures>=2)render(true);}
  finally{clearTimeout(timeout);busy=false;}
 }
 check();setInterval(check,60000);
 document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')check();});
 window.addEventListener('pageshow',event=>{if(event.persisted)check();});
})();
